import relaunchTime from '../../../../../config/relaunchTime.json';

export default function (t) {
	const rel =
		relaunchTime[t === 'start' ? 'startCountdown' : 'relaunchTime'].split(' ');
	const date = rel[0].split('-');

	const time = rel[1].split(':');

	return new Date(
		Date.UTC(date[0], date[1] - 1, date[2], time[0], time[1], time[2])
	);
}
